export {default} from './Mind';